module.exports = __webpack_public_path__ + "img/bg-1-mobile.8c81252d.png";